<template>
	<sheet-label-formatted
		class="simulated-record"
		:class="{
			ghost: isGhost,
			'cut-right': endsLaterThanRightBoundary,
			'cut-left': startersEarlierThanLeftBoundary,
		}"
		:style="computedStyle"
		:formatting="labelFormatting"
	>
		<r-shadow :height="1" class="preview">
			{{ datePreviewText }}
		</r-shadow>
	</sheet-label-formatted>
</template>

<script>
import Config from 'config';

import SheetLabelFormatted from 'vue/sheet-views/labels/sheet-label-formatted.vue';

export default {
	mounted() {
		// debugger
	},
	props: {
		isGhost: {
			required: false,
			type: Boolean,
			default: false,
		},
		endsLaterThanRightBoundary: {
			required: false,
			type: Boolean,
			default: false,
		},
		startersEarlierThanLeftBoundary: {
			required: false,
			type: Boolean,
			default: false,
		},
		startX: {
			required: true,
			type: Number,
		},
		endX: {
			required: true,
			type: Number,
		},
		startY: {
			required: false,
			type: Number,
			default: 0,
		},
		labelFormatting: {
			required: false,
			type: Object,
			default() {
				return Config.dataStore.formatting.defaultFormat;
			},
		},
		datePreviewText: {
			required: false,
			type: String,
		},
	},
	components: {
		SheetLabelFormatted,
	},
	computed: {
		computedStyle() {
			return {
				width: `${this.endX - this.startX}px`,
				transform: `translate(${this.startX}px, ${this.startY}px)`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.simulated-record {
	position: absolute;
	height: 32px;
	line-height: 32px;
	margin-top: 4px;
	box-sizing: border-box;
	border-radius: 3px;
	background: rgba(255, 255, 255, 0.7);
	border: 2px solid #2c2c38;
	z-index: 5;

	&.ghost {
		border: 2px dashed #2c2c38;
		border-radius: 3px;
		background: transparent;
		z-index: 10;

		&.cut-right {
			border-right: none;
			border-radius: 3px 0 0 3px;
		}

		&.cut-left {
			border-left: none;
			border-radius: 0 3px 3px 0;
		}

		&.cut-right.cut-left {
			border-radius: 0;
		}
	}
}

.ghost {
	.preview {
		display: none;
	}
}

.preview {
	position: absolute;
	height: 24px;
	background: #2c2c38;
	color: white;
	bottom: -31px;
	left: -1px;
	width: max-content;
	font-size: 14px;
	letter-spacing: 0.3px;
	border-radius: 3px;
	line-height: 24px;
	padding-left: 9px;
	padding-right: 9px;
	user-select: none;
}
</style>
